import { render, staticRenderFns } from "./FormQueue.vue?vue&type=template&id=1a55bc32&"
import script from "./FormQueue.vue?vue&type=script&lang=js&"
export * from "./FormQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports